(() => {
  let scriptRequested = false;
  let trackingEnabled = false;
  let attempts = 0;
  let featureAttempts = 0;

  function syncClarityConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    let analyticsAllowed = false;
    let adsAllowed = false;

    try {
      // Shopify combines regional settings with the visitor's consent choices.
      analyticsAllowed = privacy?.analyticsProcessingAllowed() === true;
      adsAllowed = analyticsAllowed &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (error) {
      // Missing or unavailable privacy data must never enable tracking.
      analyticsAllowed = false;
      adsAllowed = false;
    }

    if (!analyticsAllowed && !scriptRequested) return;

    if (!scriptRequested) {
      scriptRequested = true;
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/mtwo2kv2i5';
      document.head.appendChild(script);
      trackingEnabled = true;
    } else if (analyticsAllowed && !trackingEnabled) {
      window.clarity('start');
    }

    window.clarity('consentv2', {
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
      ad_Storage: adsAllowed ? 'granted' : 'denied'
    });

    // Denying cookie consent alone still permits Clarity's cookieless tracking.
    if (!analyticsAllowed && trackingEnabled) window.clarity('stop');
    trackingEnabled = analyticsAllowed;
  }

  function initializePrivacy() {
    if (window.Shopify?.customerPrivacy) {
      syncClarityConsent();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      if (featureAttempts >= 4) return;
      featureAttempts++;
      const retry = () => {
        if (featureAttempts < 4) {
          window.setTimeout(initializePrivacy, 500 * Math.pow(2, featureAttempts - 1));
        }
      };
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error || !window.Shopify?.customerPrivacy) {
            retry();
          } else {
            syncClarityConsent();
          }
        });
      } catch (error) {
        retry();
      }
    } else if (attempts++ < 100) {
      window.setTimeout(initializePrivacy, 100);
    }
  }

  document.addEventListener('visitorConsentCollected', syncClarityConsent);
  window.addEventListener('pageshow', syncClarityConsent);
  initializePrivacy();
})();
